import {
  CERT_DETAILS_COLUMNS_TO_SHOW,
  CERT_DETAILS_LISTS_LOADING,
  CERT_DETAILS_REFRESH_SUCCESS,
  CERT_DETAILS_VIEW_API_ERROR,
  CERT_DETAILS_VIEW_API_UNAUTHORIZED_ERROR,
  CERT_DETAILS_VIEW_LOADING,
  SET_CERT_DETAILS_CAMPAIGN_KEY,
  SET_CERT_DETAILS_LISTS,
  SET_CERT_DETAILS_LISTS_COUNT,
  SET_CERT_DETAILS_SEARCH_TEXT,
  SET_CERT_DETAILS_SELECTALL_COUNT,
  SET_CERT_DETAILS_TERMINATE_COMMENTS,
  SET_CERT_DETAILS_TERMINATE_CONFIG_MAP,
  SET_CERT_ITEMS_OFFSET_COUNT,
  SET_CERT_TRUST_SCORE_FLAG,
  SET_PREDEFINED_COMMENTS,
} from '../types';

const INITIAL_STATE = {
  campaignType: null,
  isLoading: true,
  isRefreshSuccess: false,
  certDetailsLists: null,
  totalItems: 0,
  selectAllCount: 0,
  isViewApiError: false,
  isViewApiLoading: false,
  isViewApiUnauthorizedError: false,
  isTrustScoreEnabled: false,
  columnNames: null,
  configMap: {},
  searchText: '', // Kept here, not in viewControl reducer as it been used only once
  predefinedComments: {},
  itemsOffSetCount: 0,
};

// eslint-disable-next-line default-param-last
const coreReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_CERT_DETAILS_CAMPAIGN_KEY:
      return {
        ...state,
        campaignType: action?.payload,
      };

    case SET_CERT_TRUST_SCORE_FLAG:
      return {
        ...state,
        isTrustScoreEnabled: action?.payload,
      };

    case SET_CERT_DETAILS_LISTS_COUNT:
      return {
        ...state,
        totalItems: action?.payload,
      };
    case SET_CERT_DETAILS_SEARCH_TEXT:
      return {
        ...state,
        searchText: action?.payload,
      };
    case SET_CERT_DETAILS_SELECTALL_COUNT:
      return {
        ...state,
        selectAllCount: action?.payload,
      };
    case SET_CERT_DETAILS_LISTS:
      return {
        ...state,
        certDetailsLists: action?.payload?.results,
        totalItems: action?.payload?.total,
        searchText: action?.payload?.searchText,
        globalError: action?.payload?.error,
      };
    case SET_CERT_ITEMS_OFFSET_COUNT:
      return {
        ...state,
        itemsOffSetCount: action.payload,
      };

    case CERT_DETAILS_LISTS_LOADING:
      return {
        ...state,
        isLoading: action?.payload,
      };

    case CERT_DETAILS_REFRESH_SUCCESS:
      return {
        ...state,
        isRefreshSuccess: action?.payload,
      };

    case CERT_DETAILS_VIEW_LOADING:
      return {
        ...state,
        isViewApiLoading: action?.payload,
      };
    case CERT_DETAILS_VIEW_API_UNAUTHORIZED_ERROR:
      return {
        ...state,
        isViewApiUnauthorizedError: action?.payload?.isError,
      };
    case CERT_DETAILS_VIEW_API_ERROR:
      return {
        ...state,
        isViewApiError: action?.payload?.isError,
      };

    case CERT_DETAILS_COLUMNS_TO_SHOW:
      return {
        ...state,
        columnNames: action?.payload,
      };

    case SET_CERT_DETAILS_TERMINATE_CONFIG_MAP:
      return {
        ...state,
        configMap: action?.payload,
      };

    case SET_CERT_DETAILS_TERMINATE_COMMENTS:
      return {
        ...state,
        enableIndividualCommentsForUsers: action?.payload,
      };

    case SET_PREDEFINED_COMMENTS:
      return {
        ...state,
        predefinedComments: action.payload.comments,
      };

    default:
      return state;
  }
};

export default coreReducer;
